package one.healthium.health_log.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultHealthLogComponent(
    componentContext: ComponentContext,
    override val taskId: String? = null,
    private val onCloseClicked: () -> Unit,
) : HealthLogComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
}